import React from "react";
import { useEffect, useState, createContext } from "react";
import "./App.scss";
import "./common/commonStyles.scss";
import AppRouter from "./AppRouter";
import Footer from "./components/footer/Footer";
import { Provider } from "react-redux";
import store from "./store/store";
import { useIdleTimer } from "./utils/useIdleTimer";
import { useTokenRefresh } from "./utils/useTokenRefresh";
import RefreshToken from "./components/login/RefreshToken";
import { fetchMyaccountLogin } from "./store/Myaccount/myaccountActions";
import { useSearchParams } from "react-router-dom";

export const SearchContext = createContext();
export const MyAccountContext = createContext(null);

function App() {
  const [searchProviderParams, setSearchProviderParams] = useState({
    field: "all",
    pageNumber: 1,
    pageSize: 10,
    query: "",
    view: "search",
  });
  const [searchPracticeParams, setSearchPracticeParams] = useState({
    field: "all",
    pageNumber: 1,
    pageSize: 10,
    query: "",
    view: "search",
  });

  const [searchParams] = useSearchParams();
  const searchQueryParam = searchParams.get("search") || "";
  const [userIsIdle, setUserIsIdle] = useState(false);
  const token = localStorage.getItem("auth-key");
  const isIdle = useIdleTimer(600000, !!token);
  useTokenRefresh(!!token);

  const [user, setUser] = useState(null);
  const [grantedRoles, setGrantedRoles] = useState([]);

  useEffect(() => {
    if (isIdle) {
      setUserIsIdle(true);
    } else {
      setUserIsIdle(false);
    }
  }, [isIdle]);

  useEffect(() =>{
    setSearchPracticeParams({
      ...searchPracticeParams,
      query: searchQueryParam,
    })
    setSearchProviderParams({
      ...searchProviderParams,
      query: searchQueryParam,
    })
  },[searchQueryParam])

  useEffect(() => {
    if (localStorage.getItem("auth-key") !== null) {
      store.dispatch(fetchMyaccountLogin());
    }
    const unsubscribe = store.subscribe(() => {
      const state = store.getState();
      const myaccountData = state.myaccountLoginInformation;
      const { myaccountLogin } = myaccountData || {};

      const userData = myaccountLogin?.user;
      const roles = userData?.grantedRoles || [];
      if (myaccountLogin?.token) {
        localStorage.setItem("auth-key", myaccountLogin?.token);
      }

      setUser(userData);
      setGrantedRoles(roles);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <MyAccountContext.Provider value={{ user, grantedRoles }}>
          <SearchContext.Provider
            value={{
              searchPracticeParams,
              searchProviderParams,
              setSearchPracticeParams,
              setSearchProviderParams,
            }}
          >
            <main>
              <div className="mainContainer">
                <AppRouter />
              </div>
            </main>
            <Footer />
          </SearchContext.Provider>
          <div>
            {userIsIdle && localStorage.getItem("auth-key") && (
              <RefreshToken
                isPopupOpen={userIsIdle}
                closeCallback={() => {
                  setUserIsIdle(false);
                }}
              />
            )}
          </div>
        </MyAccountContext.Provider>
      </Provider>
    </div>
  );
}

export default App;
